import services from "../services";
import * as types from "./mutation-type";

export const setCategory = ({ commit }, payload) => {
    commit(types.SET_CATEGORY, payload);
};

export const setProducts = ({ commit }, payload) => {
    commit(types.SET_PRODUCTS, payload);
};

export const setPagination = ({ commit }, payload) => {
    commit(types.SET_PAGINATION, payload);
};

export const ActionGetProducts = async ({ _ }, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.getListProducts(payload);
        if (data.error === false) {
            resolve(data);
        }
        reject(data);
    });
};
